/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import Link from "@material-ui/core/Link"
import { useDispatch, useSelector } from "react-redux"
import { Box } from "@material-ui/core"
import { defineMessages } from "react-intl"
import useEnvironment from "../hooks/useEnvironment"
import LocaleSelect from "./select/LocaleSelect"
import { updateLocale } from "../i18n/localeUtils"
import useSmartFormat from "../i18n/useSmartFormat"
import licenseSlice from "../pages/admin/licensing/licenseSlice"

const messages = defineMessages({
  licenseAgreement: {
    id: "licenseAgreement.title",
    defaultMessage: "End-user license agreement"
  }
})

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[5]
  },
  footerLeft: {
    "& button": {
      fontSize: "0.75rem"
    },
    "& > *": {
      marginRight: theme.spacing(2)
    }
  }
}))

function FooterLeft() {
  const format = useSmartFormat()
  const env = useEnvironment()
  const classes = useStyles()
  const dispatch = useDispatch()
  const licenseConfiguration = useSelector(
    (state) => state.license.configuration
  )

  function onCopyrightClick() {
    window.open(env.website, "_blank")
  }

  function onLicenseAgreementClick() {
    dispatch(
      licenseSlice.actions.setLicenseDialogIsShowing({
        isShowing: true,
        isPreview: true
      })
    )
  }

  // ESLint bug: None of these are even an anchor (component="button")
  return (
    <Box className={classes.footerLeft} display="flex" alignItems="center">
      <Link component="button" color="inherit" onClick={onCopyrightClick}>
        Copyright © {`${env.customer_name} ${new Date().getFullYear()}`}
      </Link>
      {licenseConfiguration?.enabled && (
        <Link component="button" onClick={onLicenseAgreementClick}>
          {format(messages.licenseAgreement)}
        </Link>
      )}
    </Box>
  )
}

function AppFooter() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const currentLocale = useSelector((state) => state.intl.locale)

  function onLocaleChange(newLocale) {
    dispatch(updateLocale(newLocale))
  }

  return (
    <footer className={classes.footer}>
      <Container maxWidth="lg">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <FooterLeft />
          <LocaleSelect onChange={onLocaleChange} value={currentLocale} />
        </Box>
      </Container>
    </footer>
  )
}

export default AppFooter
